import React, { useState } from 'react';
import "../../constants/styles/preSession.scss";

const InputPanel = ({ onContinue, setHashedInput }) => {
    const [inputValue, setInputValue] = useState('');
    const [isValid, setIsValid] = useState(true);

    const hashInputValue = async (input) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(input);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert buffer to byte array
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // Convert bytes to hex string
        return hashHex;

    };

    const handleContinueClick = async () => {
        if (/^\d{6}$/.test(inputValue)) {
            setIsValid(true);
            const hashedInput = await hashInputValue(inputValue);
            setHashedInput(hashedInput); // Pass the hashed input up
            onContinue(inputValue); // Pass the raw user ID up as well
        } else {
            setIsValid(false);
        }
    };



    return (
        <div className='pre-session-container'>
            <h1 className="intro">Sign up for the study</h1>
            <div className='text-panel-input'>
                <p>Please provide the ID given to you at the reception:</p>
                <div className="input-group">
                    <label htmlFor="idInput">ID:</label>
                    <input
                        id="idInput"
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        className={`input-field ${!isValid ? "input-invalid" : ""}`}
                        placeholder="Enter your ID here"
                    />
                </div>
                {!isValid && <p className="error-text">Please enter a valid 6-digit ID.</p>}
            </div>
            <div className="button-container">
                <button className="continue-button" onClick={handleContinueClick}>
                    Continue
                </button>
            </div>
        </div>
    );
};

export default InputPanel;
